export default __webpack_public_path__ + "static/media/icon-depot-start.0fa0ee3a.svg";